import { createContext as t } from "react";
const o = t(null), p = {
  activeStep: 1,
  totalSteps: 0
};
export {
  o as StepsContext,
  p as defaultStepsState
};
